import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Button, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  IconButton 
} from '@mui/material';
import { CheckCircle as CheckCircleIcon, Cancel as CancelIcon } from '@mui/icons-material';
import axios from 'axios';

function AprobarNegocios() {
  const [empresasPendientes, setEmpresasPendientes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEmpresasPendientes();
  }, []);

  const fetchEmpresasPendientes = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/aprobarempresa/pendientes`);
      setEmpresasPendientes(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error al obtener las empresas pendientes:', error);
      setLoading(false);
    }
  };

  const handleAprobar = async (id_empresa) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/aprobarempresa/aprobar`, { id_empresa, aprobar: true });
      fetchEmpresasPendientes();
    } catch (error) {
      console.error('Error al aprobar la empresa:', error);
    }
  };

  const handleRechazar = (id_empresa) => {
    if (window.confirm('¿Estás seguro de rechazar esta empresa?')) {
      // Podrías implementar una lógica de rechazo si es necesario
      console.log(`Empresa con ID ${id_empresa} rechazada`);
    }
  };

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Empresas Pendientes de Aprobación
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Documento</TableCell>
              <TableCell>Contacto</TableCell>
              <TableCell>Teléfono</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>País</TableCell>
              <TableCell>Rubro</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {empresasPendientes.map((empresa) => (
              <TableRow key={empresa.id_empresa}>
                <TableCell>{empresa.nombre_empresa}</TableCell>
                <TableCell>{empresa.nro_doc_empresa}</TableCell>
                <TableCell>{empresa.contacto_empresa}</TableCell>
                <TableCell>{empresa.telefono_empresa}</TableCell>
                <TableCell>{empresa.email_empresa}</TableCell>
                <TableCell>{empresa.det_pais}</TableCell>
                <TableCell>{empresa.det_rubro}</TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => handleAprobar(empresa.id_empresa)}>
                    <CheckCircleIcon />
                  </IconButton>
                  <IconButton color="secondary" onClick={() => handleRechazar(empresa.id_empresa)}>
                    <CancelIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}

export default AprobarNegocios;
